<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          :width="user.role === 'admin' ? 500 : 400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                <div>
                  <div
                    class="body-2 black--text mb-2">
                    Periode
                  </div>
                  
                  <v-autocomplete
                    filled
                    rounded
                    dense

                    :color="set_color"
                    placeholder="Contoh. 2023"

                    :hide-details="user.role === 'admin' ? false : true"

                    :items="years"
                    :item-color="set_color"

                    v-model="filter.year"
                    :class="user.role === 'admin' ? '' : 'mb-2'"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div>

                <!-- <div v-if="user.role === 'admin'">
                  <div
                    class="body-2 black--text mb-2">
                    Unit
                  </div>
                  
                  <v-autocomplete
                    filled
                    rounded
                    dense

                    :color="set_color"
                    placeholder="Contoh. Badan Pengelolaan Keuangan"

                    hide-details

                    :items="unit"
                    item-text="title"
                    item-value="id"
                    :item-color="set_color"

                    v-model="filter.unit_id"
                    class="mb-2"
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </div> -->
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data 

              <b class="font-weight-bold black--text">
                {{ selected.row_sub_kegiatan.length > 0 ? 'Sub Kegiatan'  : selected.row_kegiatan.length > 0 ? 'Kegiatan' : 'Program' }}
              </b> 

              yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.deleteProgram"
          @keydown.esc="dialog.deleteProgram = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.deleteProgram = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data 

              <b class="font-weight-bold black--text">
                Semua Program ?
              </b> 

            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletesProgram()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.deleteProgram = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Program
                    </span>
                  </div>

                  <v-spacer />

                  <div class="d-flex aling-center">
                    <v-btn v-if="user.role === 'admin' && filter.unit_id !== '' && filter.unit_id !== null"
                      @click="dialog.deleteProgram = true"
                      color="red"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center ml-4"
                      style="border-radius: 10px; font-weight: 600;">
                      <v-icon size="20">mdi-trash-can-outline</v-icon>
                      
                      <span
                        class="ml-2">
                        Hapus
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            align="center"
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="7">
              <div
                class="body-2">
                Periode program 

                <span v-if="filter.year !== '' && filter.year !== null">
                  tahun <strong class="black--text">{{ filter.year }}</strong>
                </span>

                <span v-if="filter.unit_id !== '' && filter.unit_id !== null">
                  di unit <strong class="black--text">{{ filter.unit_title }}</strong>
                </span>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="5"
              justify="end"
              class="d-flex align-center" style="justify-content: end;">
              <div class="ml-3 text-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog.filter = true; fetchUnit();"
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-filter-multiple-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div>
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exports()"
                      :loading="process.export"
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-tray-full</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Export
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>

                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>

                <div class="view" v-if="!process.load">
                  <div class="wrapper">
                    <table style="border: 1px solid #ededed;" class="table">
                      <tr>
                        <th rowspan="3" class="sticky-col first-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 150px; width: 150px; text-align: center;">Aksi</th>
                        <th rowspan="3" class="sticky-col second-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 150px; width: 150px; max-width: 150px;">Program</th>
                        <th rowspan="3" class="sticky-col three-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 150px">Kegiatan</th>
                        <th rowspan="3" class="sticky-col four-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">Sub Kegiatan</th>
                        <th rowspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">PPKOM</th>
                        <th rowspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">PPTK</th>
                        <th rowspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">Nominal Anggaran</th>
                        <th rowspan="3" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 200px">Tahun Anggaran</th>
                        <th colspan="24" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">TARGET SETIAP BULAN</th>
                      </tr>
                      <tr>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Januari</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Februari</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Maret</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">April</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Mei</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Juni</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Juli</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Agustus</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">September</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Oktober</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">November</th>
                        <th colspan="2" style="font-size: 12px; top: 35px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 200px;">Desember</th>
                      </tr>
                      <tr>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 70px;">Fisik</th>
                        <th style="font-size: 12px; top: 70px; border: 1px solid #ededed;padding: 8px 12px; text-align: center; min-width: 150px;">Keuangan</th>
                      </tr>

                      <tr v-if="Object.keys(detail).length > 0">
                        <td class="sticky-col first-col font-weight-bold text-center" style="font-size: 14px; border: 1px solid #ededed;padding: 8px 12px;">Total</td>
                        <td class="sticky-col second-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td class="sticky-col three-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td class="sticky-col four-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;"></td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_1 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_1 }}</td> 
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_2 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_2 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_3 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_3 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_4 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_4 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_5 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_5 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_6 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_6 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_7 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_7 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_8 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_8 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_9 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_9 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_10 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_10 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_11 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_11 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ detail.average_target_fisik_12 }}</td>
                        <td class="font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">Rp. {{ detail.total_target_keuangan_format_12 }}</td>
                      </tr>

                      <tr v-for="(item, index) in list" :key="index">
                        <td class="sticky-col first-col" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; text-align: center;">
                          <div v-if="item.type === 'Program'">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/detail/${item.id}?unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-slab-circle-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Detail</span>
                            </v-tooltip>

                            <v-tooltip v-if="user.role === 'admin'"
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/edit/${item.id}?from=table&unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="blue"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-square-edit-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Ubah</span>
                            </v-tooltip>

                            <v-tooltip v-if="user.role === 'admin'"
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id)"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Hapus</span>
                            </v-tooltip>
                          </div>

                          <div v-if="item.type === 'Kegiatan'">
                            <v-tooltip 
                              right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/detail/${item.id}?unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-slab-circle-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Detail</span>
                            </v-tooltip>

                            <v-tooltip 
                              right v-if="user.role === 'admin'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/edit/${item.id}?from=table&unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="blue"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-square-edit-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Ubah</span>
                            </v-tooltip>

                            <v-tooltip 
                              right
                              v-if="user.role === 'admin'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id);"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Hapus</span>
                            </v-tooltip>
                          </div>

                          <div v-if="item.type === 'Sub Kegiatan'">  
                            <v-tooltip 
                              right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/detail/${item.id}?unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-slab-circle-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Detail</span>
                            </v-tooltip>
                          
                            <v-tooltip 
                              right v-if="user.role === 'admin'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :to="`/program/edit/${item.id}?from=table&unit_id=${filter.unit_id}&year=${filter.year}`"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="blue"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-square-edit-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Ubah</span>
                            </v-tooltip>

                            <v-tooltip 
                              right v-if="user.role === 'admin'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.id); rowClickSubKegiatan(item);"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Hapus</span>
                            </v-tooltip>
                          </div>
                        </td>
                        <td class="sticky-col second-col font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px; min-width: 150px; width: 150px; max-width: 150px;">{{ item.type === 'Program' ? item.title : "" }}</td>
                        <td class="sticky-col three-col font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Kegiatan' ? item.title : "" }}</td>
                        <td class="sticky-col four-col font-weight-bold" style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Sub Kegiatan' ? item.title : "" }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Sub Kegiatan' ? item.ppkom_name : "" }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.type === 'Sub Kegiatan' ? item.pptk_name : "" }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          <span v-if="item.type !== 'Sub Kegiatan'">
                            
                          </span>
                          <span v-else>
                            {{ item.anggaran | price }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          <span v-if="item.type !== 'Sub Kegiatan'">
                            
                          </span>
                          <span v-else>
                            {{ item.tahun_anggaran }}
                          </span>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_1  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_1 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_2  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_2 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_3  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_3 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_4  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_4 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_5  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_5 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_6  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_6 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_7  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_7 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_8  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_8 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_9  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_9 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_10  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_10 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_11  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_11 | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">{{ item.target_fisik_12  }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed;padding: 8px 12px;">
                          {{ item.target_keu_12 | price }}
                        </td>
                      </tr>
                    </table>
                  </div>  
                </div>  
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        expanded_program: [],
        expanded_kegiatan: [],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          deleteProgram: false
        },
        
        search: '',

        filter: {
          year: new Date().getFullYear(),

          unit_id: '',
          unit_title: ''
        },

        selected: {
          row_program: [],
          row_kegiatan: [],
          row_sub_kegiatan: [],

          freeze: [],
          delete: []
        },

        detail: {},
        unit: [],

        options: {},
        headers: [],
        headers_2: [],
        list: [],
        list_sub: [],
        list_child: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        process: {
          load: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      // '$route.query.unit': function(val) {
      //   this.filter.unit_id = val
      //   this.fetch()
      // },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },

      'filter.year': function () {
        this.fetch()
      },

      'filter.unit_id': function () {
        let t = this

        let u = this.unit.filter(function(v) {
          return t.filter.unit_id == v.id
        })

        if (u.length > 0) {
          this.filter.unit_title = u[0].title
        }
      },
      '$store.state.unit_id': function(val) {
        this.filter.unit_id = val
        this.fetch()
      },
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      unit_id () {
        return this.$store.state.unit_id
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      configHeaders_2 () {
        return this.headers_2.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      if (this.$store.state.user.role === 'opd') {
        this.filter.unit_id = this.$store.state.user.unit_id
        this.fetch()
      } else {
        // if(this.$route.query.unit !== undefined){
          //   this.filter.unit_id = this.$route.query.unit
          // } else {
          this.filter.unit_id = this.$store.state.unit_id === '' ? '501' : this.$store.state.unit_id
        // }
        this.fetch()
      }
      this.fetchUnit()
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = Number(value)
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClickProgram (item, row) {
        row.select(!row.isSelected ? true : false)

        this.expanded_program = []

        this.expanded_kegiatan = []

        this.selected.row_kegiatan = []

        this.selected.row_sub_kegiatan = []

        if (row.isExpanded) {
          const indexExpanded = this.expanded_program.findIndex(i => i === item)
          this.expanded_program.splice(indexExpanded, 1)
        } else {
          this.expanded_program.push(item)
        }
      },
      handleToggleAllProgram (event) {
        if (!event.value) this.selected.row_program = []
      },

      rowClickKegiatan (item, isExpanded) {
        this.toggleSelectionKegiatan(item.id)

        this.expanded_kegiatan = []

        this.selected.row_sub_kegiatan = []

        if (isExpanded) {
          const indexExpanded = this.expanded_kegiatan.findIndex(i => i === item)
          this.expanded_kegiatan.splice(indexExpanded, 1)
        } else {
          this.expanded_kegiatan.push(item)
        }
      },
      toggleSelectionKegiatan (keyID) {
        this.selected.row_kegiatan = []
        
        if (this.selected.row_kegiatan.includes(keyID)) {
          this.selected.row_kegiatan = this.selected.row_kegiatan.filter(selectedKeyID => selectedKeyID !== keyID)
        } else {
          this.selected.row_kegiatan.push(keyID)
        }
      },

      rowClickSubKegiatan (item) {
        this.toggleSelectionSubKegiatan(item.id)
      },
      toggleSelectionSubKegiatan (keyID) {
        this.selected.row_sub_kegiatan = []
        
        if (this.selected.row_sub_kegiatan.includes(keyID)) {
          this.selected.row_sub_kegiatan = this.selected.row_sub_kegiatan.filter(selectedKeyID => selectedKeyID !== keyID)
        } else {
          this.selected.row_sub_kegiatan.push(keyID)
        }
      },

      async fetch (pagination = { row: 200000000000000000, page: 1 }) {
        
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          search: this.search,

          tahun_anggaran: this.filter.year,
          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id
        }

        this.selected.row_program = []

        await get(`admin/task/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '140px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Kode',
                width: '200px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Judul',
                width: '400px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'PPKOM',
                width: '200px',
                value: 'ppkom_name',
                freeze: false,
                hide: false
              },
              {
                text: 'PPTK',
                width: '200px',
                value: 'pptk_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Nominal Anggaran',
                width: '200px',
                value: 'anggaran',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Tahun Anggaran',
                width: '200px',
                value: 'tahun_anggaran',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'Januari',
                width: '400px',
                value: 'target_fisik_1',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_1',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_1',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Februari',
                width: '400px',
                value: 'target_fisik_2',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_2',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_2',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Maret',
                width: '400px',
                value: 'target_fisik_3',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_3',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_3',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'April',
                width: '400px',
                value: 'target_fisik_4',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_4',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_4',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Mei',
                width: '400px',
                value: 'target_fisik_5',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_5',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_5',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Juni',
                width: '400px',
                value: 'target_fisik_6',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_6',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_6',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Juli',
                width: '400px',
                value: 'target_fisik_7',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_7',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_7',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Agustus',
                width: '400px',
                value: 'target_fisik_8',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_8',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_8',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'September',
                width: '400px',
                value: 'target_fisik_9',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_9',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_9',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Oktober',
                width: '400px',
                value: 'target_fisik_10',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_10',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_10',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'November',
                width: '400px',
                value: 'target_fisik_11',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_11',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_11',
                    format: 'number',
                    align: 'end'
                  }
                ]
              },
              {
                text: 'Desember',
                width: '400px',
                value: 'target_fisik_12',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'center',
                children: [
                  { 
                    text: 'Target' ,
                    value: 'target_fisik_12',
                    format: 'percent',
                    align: 'center'
                  },
                  { 
                    text: 'Keuangan' ,
                    value: 'target_keu_12',
                    format: 'number',
                    align: 'end'
                  }
                ]
              }
            ]

            this.headers_2 = [
              {
                text: 'Aksi',
                width: '140px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Kode',
                width: '200px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Judul',
                width: '400px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'PPKOM',
                width: '200px',
                value: 'ppkom_name',
                freeze: false,
                hide: false
              },
              {
                text: 'PPTK',
                width: '200px',
                value: 'pptk_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Nominal Anggaran',
                width: '200px',
                value: 'anggaran',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Tahun Anggaran',
                width: '200px',
                value: 'tahun_anggaran',
                freeze: false,
                hide: false,
                align: 'center'
              },
              {
                text: 'Januari (Target)',
                width: '200px',
                value: 'target_fisik_1',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Januari (Keuangan)',
                width: '200px',
                value: 'target_keu_1',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Februari (Target)',
                width: '200px',
                value: 'target_fisik_2',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Februari (Keuangan)',
                width: '200px',
                value: 'target_keu_2',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Maret (Target)',
                width: '200px',
                value: 'target_fisik_3',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Maret (Keuangan)',
                width: '200px',
                value: 'target_keu_3',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'April (Target)',
                width: '200px',
                value: 'target_fisik_4',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'April (Keuangan)',
                width: '200px',
                value: 'target_keu_4',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Mei (Target)',
                width: '200px',
                value: 'target_fisik_5',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Mei (Keuangan)',
                width: '200px',
                value: 'target_keu_5',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Juni (Target)',
                width: '200px',
                value: 'target_fisik_6',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Juni (Keuangan)',
                width: '200px',
                value: 'target_keu_6',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Juli (Target)',
                width: '200px',
                value: 'target_fisik_7',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Juli (Keuangan)',
                width: '200px',
                value: 'target_keu_7',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Agustus (Target)',
                width: '200px',
                value: 'target_fisik_8',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Agustus (Keuangan)',
                width: '200px',
                value: 'target_keu_8',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'September (Target)',
                width: '200px',
                value: 'target_fisik_9',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'September (Keuangan)',
                width: '200px',
                value: 'target_keu_9',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Oktober (Target)',
                width: '200px',
                value: 'target_fisik_10',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Oktober (Keuangan)',
                width: '200px',
                value: 'target_keu_10',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'November (Target)',
                width: '200px',
                value: 'target_fisik_11',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'November (Keuangan)',
                width: '200px',
                value: 'target_keu_11',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              },
              {
                text: 'Desember (Target)',
                width: '200px',
                value: 'target_fisik_12',
                freeze: false,
                hide: false,
                format: 'percent',
                align: 'center'
              },
              {
                text: 'Desember (Keuangan)',
                width: '200px',
                value: 'target_keu_12',
                freeze: false,
                hide: false,
                format: 'number',
                align: 'end'
              }
            ]

            // this.list = this.changeData(res.results.data)

            this.list = res.results.data
            this.pagination = res.results.pagination
            this.detail = res.results

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      getSubHeader(headers) {
        let result = []

        headers
          .filter((i) => i.children)
          .forEach((v) => {
            result = result.concat(v.children)
          })

        return result
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }
        
        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
            // if (this.$route.query.unit !== undefined) {
              this.unit.map(obj => {
                if (obj.id === this.filter.unit_id) {
                  this.filter.unit_title = obj.title
                }
              })
            // }
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          unit_id: this.filter.unit_id,
          unit_title: this.filter.unit_title,

          tahun_anggaran: this.filter.year,

          year: this.filter.year
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/task/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', `TARGET-FISIK-DAN-KEUANGAN-TAHUN-ANGGARAN-${this.filter.year}-${moment().format('HH:mm:ss', 'id')}.xlsx`)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletesProgram (){
        this.message.error = ''

        this.process.delete = true

        await post(`admin/task/delete_all`, {
          data: {
            unit_id: this.filter.unit_id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.deleteProgram = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/task/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper {
  /* position: relative;
  overflow: auto;
  white-space: nowrap; */
}

.wrapper th {
    /* background: #04a8bf5e; */
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.first-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

</style>